import script from "./BulkInviteDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkInviteDialog.vue?vue&type=script&setup=true&lang=ts"

import "./BulkInviteDialog.vue?vue&type=style&index=0&id=7972ca60&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7972ca60"]])

export default __exports__